import { entityUuidRegexStr } from "../../../../../shared/constants/entityUuidRegex";

export const apiEntityPathRegex = new RegExp(`/v4/Entities/${entityUuidRegexStr}`);
export const apiEntitiesPathRegex = new RegExp(`/v4/Entities`);
